import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { UserOutlined } from '@ant-design/icons';
import { Col, Row, Form, Input } from 'antd';
import 'react-toastify/dist/ReactToastify.css';

function ForgetPassword() {
  const navigate = useNavigate();

  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [isValidMobile, setIsValidMobile] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [loading, setLoading] = useState(false);

  // Handle mobile input
  const handleMobileChange = (e) => {
    const number = e.target.value;
    setMobile(number);
    setIsValidMobile(/^[0-9]{10}$/.test(number));
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  // SEND OTP
  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const url = `${process.env.REACT_APP_API_URL}/forget-password-otp-send`;
      const payload = {
        mob: Number(mobile),
      };

      const config = {
        method: 'POST',
        url,
        headers: {
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(payload),
      };

      const response = await axios(config);
      const res = response.data;

      if (res.success === "1") {
        localStorage.setItem("mobile", mobile);
        setIsShown(true); // ✅ Show OTP + password fields
        Swal.fire({
          icon: "success",
          title: res.message || "OTP sent successfully!",
          timer: 2000,
        });
      } else {
        setIsShown(false);
        Swal.fire({
          icon: "error",
          title: res.message || "OTP send failed!",
          timer: 2000,
        });
      }
    } catch (err) {
      setIsShown(false);
      console.error("OTP Send Error:", err);
      Swal.fire({
        icon: "error",
        title: "Something went wrong while sending OTP.",
      });
    } finally {
      setLoading(false);
    }
  };

  // SUBMIT OTP + PASSWORD
const verifyOtpAndResetPassword = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const url = `${process.env.REACT_APP_API_URL}/forget-password-update`;
    const mobile_no = localStorage.getItem("mobile");

    const payload = {
      mob: mobile_no,
      otp: otp,
      password: password,
      // app_id: process.env.REACT_APP_API_ID,
    };

    const config = {
      method: "POST",
      url,
      headers: {
        "Content-Type": "application/json",
      },
      data: JSON.stringify(payload),
    };

    const response = await axios(config);
    const res = response.data;

    if (res.success === "1") {
      localStorage.removeItem("mobile");
      Swal.fire({
        icon: "success",
        title: res.message || "Password reset successful!",
        timer: 2000,
      }).then(() => {
        navigate("/Login");
      });
    } else {
      Swal.fire({
        icon: "error",
        title: res.message || "OTP verification failed!",
        timer: 2000,
      });
    }
  } catch (err) {
    console.error("Reset Error:", err);
    Swal.fire({
      icon: "error",
      title: "Something went wrong during password reset.",
    });
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="Loginpage d-flex align-items-center">
      <div className="loginform position-relative">
        <div className="bg-white login-form height_form">
          <h3 className="mb-0 fw-bold text-center text-dark">Forgot Password</h3>

          <div className="form-login-design">
            <Form name="forget-password" autoComplete="off">
              <Row gutter={[16, 16]}>
                {!isShown && (
                  <Col span={24}>
                    <Form.Item
                      name="mobile"
                      rules={[
                        { required: true, message: "Please enter your mobile number!" },
                      ]}
                    >
                      <div>
                        <small>Mobile Number</small>
                        <Input
                          placeholder="Enter Mobile Number"
                          maxLength={10}
                          value={mobile}
                          onChange={handleMobileChange}
                          prefix={<UserOutlined style={{ padding: "9px" }} />}
                        />
                      </div>
                    </Form.Item>
                  </Col>
                )}

                {isShown && (
                  <>
                    <Col span={24}>
                      <Form.Item
                        name="otp"
                        rules={[
                          { required: true, message: "Please enter the OTP!" },
                        ]}
                      >
                        <Input
                          placeholder="Enter OTP"
                          value={otp}
                          onChange={handleOtpChange}
                          style={{ padding: "9px" }}
                        />
                      </Form.Item>
                    </Col>

                    <Col span={24}>
                      <Form.Item
                        name="password"
                        rules={[
                          { required: true, message: "Please enter new password!" },
                        ]}
                      >
                        <Input.Password
                          placeholder="New Password"
                          value={password}
                          onChange={handlePasswordChange}
                          style={{ padding: "9px" }}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}

                <Col span={24}>
                  <Form.Item>
                    {loading ? (
                      <div className="text-center">Loading...</div>
                    ) : isShown ? (
                      <button
                        type="button"
                        className="btn btn-success w-100"
                        onClick={verifyOtpAndResetPassword}
                      >
                        Submit
                      </button>
                    ) : (
                      <button
                        type="submit"
                        className="btn btn-primary w-100"
                        disabled={!isValidMobile}
                        onClick={onSubmit}
                      >
                        Send OTP
                      </button>
                    )}
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
